/**
 * Centralized title management utility
 * Handles document title updates with consistent formatting
 */

/**
 * Update the page title with consistent formatting
 * @param {string} pageName - The name of the current page/route
 * @param {string} agencyName - The agency name from branding
 */
export const updatePageTitle = (pageName, agencyName) => {
  const brand = agencyName || 'Sales AI';
  document.title = pageName && pageName !== '' ? `${pageName} | ${brand}` : brand;
};

export default updatePageTitle;